import React from "react";
import * as yup from "yup";
import { Input } from "../../../../../../shared/Input/Input";
import { useFormik } from "formik";
import { InputLabel } from "../../../../../../shared/InputLabel/InputLabel";
import classes from "../scss/ClientWalletPatientFi.module.scss";
import { Button } from "../../../../../../shared/Button/Button";
import { CircularProgress } from "../../../../../../shared/CircularProgress/CircularProgress";
import { useEnrollExistingPatient } from "../hooks/useEnrollExistingPatient";
import { uiNotification } from "../../../../../../services/UINotificationService";
import { Skeleton } from "../../../../../../shared/Skeleton/Skeleton";

const PatientFiModalEmailForm = ({ onClose, client }) => {
  const { mutate, isLoading } = useEnrollExistingPatient();

  const { values, setFieldValue, errors, handleSubmit } = useFormik({
    validationSchema: yup.object({
      account: yup.string().required(),
    }),
    initialValues: {
      account: client.email,
    },
    enableReinitialize: true,
    onSubmit: (values) =>
      mutate(
        {
          patientId: client.id,
          account: values.account,
        },
        {
          onSuccess: () => {
            onClose();
          },
          onError: (error) =>
            uiNotification.error(error.response?.data?.message),
        },
      ),
  });
  return (
    <>
      <div className={classes.accountForm}>
        <InputLabel>Email or Account Number</InputLabel>
        {client.isLoading ? (
          <Skeleton height={36} />
        ) : (
          <Input
            size="small"
            value={values.account}
            onChange={(event) => setFieldValue("account", event.target.value)}
            isError={Boolean(errors.account)}
            placeholder="Enter Email or Account Number"
          />
        )}
      </div>
      <div className={classes.footerContainer}>
        <Button
          size="small"
          variant="outlined"
          onClick={onClose}
          isDisabled={isLoading || client.isLoading}
        >
          Cancel
        </Button>
        <Button
          size="small"
          onClick={handleSubmit}
          isDisabled={isLoading || client.isLoading}
          leftAdornment={
            isLoading ? <CircularProgress size="tiny" color="white" /> : null
          }
        >
          Save
        </Button>
      </div>
    </>
  );
};

export default PatientFiModalEmailForm;
